import { ListItem, OrderedList } from '@chakra-ui/react'
import React from 'react'
import NotAvailable from './NotAvailable'

const OrderedListComp = ({ array }) => {
    return (
        <OrderedList spacing={1} p="4">
            {
                array.length === 0 ? <NotAvailable /> :
                    array.map((item, index) => <ListItem key={index}>{item}</ListItem>)
            }
        </OrderedList>
    )
}

export default OrderedListComp